import { isNumber } from './componentHelpers';

export const isValidDistanceV2 = (standardFulfillmentDistance: number, actualDistance: number) => {
  return isNumber(standardFulfillmentDistance) ? actualDistance <= standardFulfillmentDistance * 1000 : true;
};
